/**
 * Box–Muller transform (plan §0.2).
 * sqrt(-2·ln(max(R(),1e-9)))·cos(2π·R())
 */
import type { Rng } from './types';

const U_FLOOR = 1e-9;

export function gauss(R: Rng): number {
  const u = Math.max(R(), U_FLOOR);
  const v = R();
  return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
}
